import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const getPaymentProcessorslist = () => {
  return function (dispatch) {
    return AssessmentServiceApi.getPaymentProcessors()
      .then((response) => {
        if (!!response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const updatePaymentProcessorDetails = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.updatePaymentProcessorDetails(data)
      .then((response) => {
        if (!!response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const isAdminUser = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.isAdminUser(data)
      .then((response) => {
        if (!!response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { getPaymentProcessorslist, updatePaymentProcessorDetails, isAdminUser };
